import * as PIXI from "pixi.js";
import UILayer from "./UILayer";
import PayAmount from "../entities/payAmount/PayAmount";
import TotalWon from "../entities/TotalWon";
import OptionsButton from "../entities/buttons/OptionsButton";
import PrizeChartButton from "../entities/buttons/PrizeChartButton";
import PlayButton from "../entities/buttons/PlayButton";
import AutoPlayButton from "../entities/buttons/AutoPlayButton";
import BonusPlayButton from "../entities/buttons/BonusPlayButton";

import { EventBus, EnumEventBus } from "../managers/EventBus";

import { BarBGBounds } from "../types/Interface";


export default class ButtonLayer extends PIXI.Container {
  static instance: ButtonLayer;
  private UILayer = UILayer.getInstance();
  private EventBus = EventBus;
  private PlayButton: PlayButton;
  private AutoPlayButton: AutoPlayButton;

  constructor(bounds, isVertical) {
    super();
    if (!ButtonLayer.instance) {
      ButtonLayer.instance = this;
    }

    new PayAmount(bounds.payAmount as BarBGBounds);
    new TotalWon(bounds.totalWon as BarBGBounds);
    new OptionsButton(bounds.optionsButton);
    new PrizeChartButton(bounds.prizeChartButton);

    this.PlayButton = new PlayButton(bounds.playButton, isVertical);
    this.AutoPlayButton = new AutoPlayButton(bounds.autoPlayButton, isVertical);
    new BonusPlayButton(bounds.playButton)

    this.EventBus.on(EnumEventBus.setHowToPlayMode, booleanString => {
      setTimeout(() => {
        this.visible = !JSON.parse(booleanString)
      }, 100);
    })
    this.addToLayer();
  }

  addToLayer() {
    this.UILayer.addChild(this);
  }
  static getInstance() {
    return ButtonLayer.instance
  }
}